import { Pipe, PipeTransform, inject } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";
import { HelpersService } from "./../../helpers-service/helpers.service";
import { ITranslateObject } from "../../../views-interfaces/translate-object.interface";

@Pipe({
    name: "wkTranslate",
    pure: false,
    standalone: true,
})
export class WkTranslatePipe extends TranslatePipe implements PipeTransform {
    private helpersService = inject(HelpersService);

    constructor() {
        super();
    }

    transform(value: string | ITranslateObject, args?: any): string | null {
        try {
            if (typeof value === "object") {
                const currentLang = this.helpersService.getLang();
                const fallbackLang = currentLang === "en-CA" ? "fr-CA" : "en-CA";
                // Return translation in fallback language in case it is absent in current language
                return value[currentLang] ?? value[fallbackLang];
            }
        } catch (ex) {}
        return super.transform(value as string, args);
    }
}
